import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { useEffect, useState } from 'react';
import logo from './../../../assets/img/logo.png';

const Header = (props) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // use state to track auth instead of checking localStorage directly
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('auth_token')
  );

  const logoutSubmit = (e) => {
    e.preventDefault();

    axios.post('/api/logout').then(res => {
      if (res.data.status === 200) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_name');
        swal('Success', res.data.message, 'success');

        setIsAuthenticated(false);        
        navigate('/');
      }
    }).catch(error => {
        // 3. IMPROVEMENT: Handle server error/token expiry gracefully on client
        console.error("Logout failed on server:", error);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_name');
        setIsAuthenticated(false);
        swal('Success', 'Logged out successfully (Client clear)', 'success');
        navigate('/');
    });
  };

  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem('auth_token'));
  }, []);

  return (
    <>

    <header className="header_area clearfix">
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="menu_area">
                        <nav className="navbar navbar-expand-lg align-items-center">
                            <Link to="/" className="navbar-brand d-flex align-items-center">
                              <img src={logo} title="Welcome to MIPAT Group" alt="MIPAT" 
                                className="logo-sm" /> &nbsp; 
                                <div style={{ lineHeight: '85%', color: '#066638' }}>
                                  <small><b>Integrated Farms and <br />
                                Food Processing Ltd</b></small>
                                </div>
                            </Link>

                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#mosh-navbar" aria-controls="mosh-navbar" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>

                            <div className="collapse navbar-collapse justify-content-end" id="mosh-navbar">
                                <ul className="navbar-nav animated" id="nav">
                                    <li className="nav-item active">
                                      <Link to="/" className="nav-link">Home</Link>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="moshDropdown" role="button" 
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Our Products</a>
                                        <div className="dropdown-menu" aria-labelledby="moshDropdown">
                                          <Link to="/products" className="dropdown-item">All Products Shop</Link>
                                          <hr />
                                          <Link to="/products/spillclean-powder" className="dropdown-item">SpillClean Powder</Link>
                                          <Link to="/products/fertilizer-and-water-mixing-machine" className="dropdown-item">Fertilizer &amp; Water Mixing Machine</Link>
                                          <Link to="/products/cocopeat-and-coconut-husk-chips" className="dropdown-item">Cocopeat &amp; Coconut Husk Chips</Link>
                                        </div>
                                    </li>
            
                                    <li className="nav-item"><Link to="/about" className="nav-link">About</Link></li>

                                    <li className="nav-item"><Link to="/contact" className="nav-link">Contact</Link></li>

                                    {isAuthenticated ? (
                                      <li className="nav-item">
                                          <button 
                                              type="button" 
                                              onClick={logoutSubmit} 
                                              className="btn btn-link nav-link" 
                                              style={{ background: '#e7ab3c', color: 'black', border: 'none', cursor: 'pointer' }} 
                                          >
                                              Logout ({localStorage.getItem('auth_name')})
                                          </button>
                                      </li>
                                    ) : (
                                      <li className="nav-item"><Link to="/login" className="nav-link">
                                          <i className="fa fa-lock"></i> Login</Link></li>
                                    )}
                                </ul>
                                
                                <div className="search-button d-flex">
                                  <Link to="/cart" className="nav-link text-dark" style={{ fontWeight: '600'}}>
                                    <i className="fa fa-shopping-cart"></i> Cart</Link>
                                </div>
                              
                                <div className="btn mosh-btn login-btn">
                                  <Link to="/products" title="Browse and shop our products">Shop Now!</Link>
                                </div>

                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </header>
    </>
  );
};
export default Header;